// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__A1WKd","fill":"button_fill__0xX3D","border":"button_border__uJN48","default":"button_default__e6bg1","small":"button_small__DyNW9"};